<ul class="nav navbar-nav navbar-right first-level">
  <ng-content />
</ul>
